module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAPBJREFUOE9j/Owslv6PkamFkZFRhIEE8P8/wwfm//8LGD+5SL5nYGQQIEEvQun//28YP7lK/idLM1QT9Q3gnrWP4fvEcoZ/V0+jOIxJ25SBq2o6w5doExRxDBeAFdbOZvjWnAo3BCzWvIjhR38Jw5/DW/EbAJJFNgTEx6UZJIczDMCG1M1hYGBjZ/jRV4xhM8wZ+A1oWczA8OcPw7eGRIwwwWsAsp//vXuFESbIgYA9ENECDFvA4nQBz7KzDD+m12H4GR6NseYMDP/+wh1BWkJiYkbRjDcWiE3elGcmUHb+z8jUwkBidmb4z/CB6f//AgB/wIeT60MgXQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/housework/delete.png
// module id = +YII
// module chunks = 5